module.exports = __webpack_public_path__ + "img/4.9f0e5595.jpg";